import { pxToRem, themeGet } from '@pocketlaw/tetris';
import styled from 'styled-components';
export const Grid = styled.div `
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-template-rows: 2fr;
  align-content: center;
  place-items: stretch stretch;
  gap: 0 ${themeGet('spacing.lg')};
`;
export const LabelContainer = styled.label `
  display: flex;
  flex-direction: column;
  padding: ${themeGet('spacing.md')};
  border-radius: ${themeGet('borderRadius.md')};
  border: ${pxToRem(1)} solid ${themeGet('colors.border.100')};
  gap: ${themeGet('spacing.md')};
`;
